import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Video from '../../../../interfaces/video';

import DropdownMenu from '../../../ui/DropdownMenu';

import { useDropdown } from '../../../../hooks';

import { AppState } from '../../../../store';

import * as Styles from './HelpContainerStyles';

const HelpContainer: React.FC = () => {
  const videos = useSelector<AppState, Video[]>((state) => state.onboarding.videos);

  const { showMenu, toggleMenu } = useDropdown();
  const [shouldShowBadge, setShouldShowBadge] = useState<boolean>(true);

  const handleVideoClick = (videoId: string): void => {
    MdHub.command.send('platform.onboarding-modal', 'setPlatform', 'dispenser');
    MdHub.command.send('platform.onboarding-modal', 'setVideoId', videoId);
    MdHub.module.show('platform.onboarding-modal');
  };

  const secondsToMinutesStr = (seconds: number): string => {
    const minutes = seconds < 1 ? 0 : Math.floor(seconds / 60);
    const secondsRemaining = Math.floor(seconds < 1 ? seconds * 100 : seconds - minutes * 60);

    let minutesStr = String(minutes);
    let secondsStr = String(secondsRemaining);

    if (minutesStr.length === 1) {
      minutesStr = `0${minutesStr}`;
    }

    if (secondsStr.length === 1) {
      secondsStr = `0${secondsStr}`;
    }

    return `${minutesStr}:${secondsStr}`;
  };

  useEffect(() => {
    setShouldShowBadge(!videos.some(({ wasWatched }) => wasWatched));
  }, [videos]);

  return (
    <Styles.Container>
      <Styles.Button
        type="button"
        className={`tracking-help-menu-dispensador ${showMenu.help ? 'active' : ''}`}
        onClick={(): void => toggleMenu('help')}
        id="dropdown-container-help"
        data-testid="dropdown-container-help"
      >
        {shouldShowBadge && <Styles.Badge />}
        Ajuda
      </Styles.Button>
      <DropdownMenu open={showMenu.help}>
        <Styles.List>
          {videos.map((video) => (
            <Styles.Item
              key={video.id}
              data-testid={video.id}
              onClick={(): void => handleVideoClick(video.id)}
              className="tracking-help-menu-video"
            >
              <Styles.ImageWrapper>
                <Styles.Image src={video.thumbnail_medium} alt={video.title} />
                {video?.wasWatched ? (
                  <Styles.CheckIcon />
                ) : (
                  <>
                    <div className="purple-bg" />
                    <Styles.PlayIcon />
                  </>
                )}
              </Styles.ImageWrapper>
              <Styles.VideoInfo>
                <h6>{video.title}</h6>
                <p>{secondsToMinutesStr(video?.total_time)}</p>
              </Styles.VideoInfo>
            </Styles.Item>
          ))}
        </Styles.List>
        <Styles.Link
          href="https://suporte-farmacia.memed.com.br/hc/pt-br"
          target="_blank"
          rel="noopener noreferrer"
          className="tracking-help-menu-central-ajuda"
        >
          Central de Ajuda
        </Styles.Link>
      </DropdownMenu>
    </Styles.Container>
  );
};

export default HelpContainer;
